import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoConciergeinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM7 6v6h2V6H7zm0-3v2h2V3H7z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgInfoConciergeinline;
